import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import React, { useEffect } from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import ConnectIntegrationButton from "../../../common/button/connectintegrationbutton.component.jsx"
import { SelectOption } from "../../../common/types"
import { InventoryLocationSelectComponent } from "../../../inventory/components"
import { Intl } from "../../../state/helpers/IntlProps"
import { INTEGRATION_KEY } from "../../../state/integration/Constants"
import { ConfigurationFreshbooks } from "../../../state/integration/IntegrationConfiguration"
import IntegrationConfigurationValue, {
    INTEGRATION_CONFIGURATION_KEYS,
    IntegrationConfigurationValueDto
} from "../../../state/integration/IntegrationConfigurationValue"
import ConfigurationValueComponent from "../ConfigurationValueComponent"

type OwnProps = {
    integrationConfigurationId: string,
    configuration: ConfigurationFreshbooks,
    configurationValues: Array<IntegrationConfigurationValueDto>,
    onConfigurationChange: (configuration: ConfigurationFreshbooks) => void,
    toggleSaveButtonStatus: (enabled: boolean) => void,
    intl: Intl,
}

const FreshbooksFormComponent = (props: OwnProps) => {


    useEffect(() => {
        props.toggleSaveButtonStatus(isSaveEnabled(props.configuration))
    }, [props.configuration])


    if (!props.integrationConfigurationId) {

        const url = AppContext.getOptions().apiUrl + `/openid/connect/${INTEGRATION_KEY.FRESHBOOKS}/` +
            AppContext.getUserLoggedIn().id

        return <div className="col-12 ui-module">
            <div className="form-group row">
                <label className="col-3 col-form-label text-align-right">
                    <FormattedMessage
                        id="integration.form.edit.connect"
                        defaultMessage="Connect"
                    />
                </label>
                <div className="col-9">
                    <ConnectIntegrationButton integrationKey={INTEGRATION_KEY.FRESHBOOKS} url={url} height={100} />
                </div>
            </div>
        </div>
    }


    return <div className="col-12 ui-module">
        <div className="form-group row">
            <label className="col-3 col-form-label text-align-right" htmlFor="accountId">
                <FormattedMessage
                    id="integration.form.edit.freshbooks.account_id"
                    defaultMessage="Account ID"
                />
            </label>
            <div className="col-9">
                <input
                    name="accountId"
                    value={props.configuration.accountId}
                    disabled={true}
                    id="accountId"
                    type="text"
                    className="form-control"
                />
            </div>
        </div>

        <div className="form-group row">
            <label className="col-3 col-form-label text-align-right" htmlFor="businessId">
                <FormattedMessage
                    id="integration.form.edit.freshbooks.business_id"
                    defaultMessage="Business ID"
                />
            </label>
            <div className="col-9">
                <input
                    name="businessId"
                    value={props.configuration.businessId}
                    disabled={true}
                    id="businessId"
                    type="text"
                    className="form-control"
                />
            </div>
        </div>

        <div className="form-group row">
            <label className="col-3 col-form-label text-align-right" htmlFor="businessUuid">
                <FormattedMessage
                    id="integration.form.edit.freshbooks.business_uuid"
                    defaultMessage="Business UUID"
                />
            </label>
            <div className="col-9">
                <input
                    name="businessUuid"
                    value={props.configuration.businessUuid}
                    disabled={true}
                    id="businessUuid"
                    type="text"
                    className="form-control"
                />
            </div>
        </div>

        <div className="form-group row">
            <label className="col-3 col-form-label text-align-right" htmlFor="inventoryLocationId">
                <FormattedMessage
                    id="integration.form.edit.freshbooks.inventory_location"
                    defaultMessage="Default inventory location"
                />
            </label>
            <div className="col-9">
                <InventoryLocationSelectComponent 
                    onChangeCallback={(selectedOption: SelectOption<string>) => {
                        props.configuration[INTEGRATION_CONFIGURATION_KEYS.defaultInventoryLocationId] = selectedOption.value
                        props.onConfigurationChange(props.configuration)
                        props.toggleSaveButtonStatus(isSaveEnabled(props.configuration))
                    } }
                    selectedValue={props.configuration.defaultInventoryLocationId}
                />
            </div>
        </div>

        {/* Filtering our default expense account since not used yet */}
        {props.configurationValues
            .filter(v => v.attributes.key !== "defaultExpenseAccountId")
            .map(v => {
                const cv = new IntegrationConfigurationValue(v)
                return (
                    <ConfigurationValueComponent
                        key={cv.getId()}
                        configurationValue={cv}
                        value={props.configuration[cv.getKey()]}
                        onChange={value => {
                            props.configuration[cv.getKey()] = value
                            props.onConfigurationChange(props.configuration)
                            props.toggleSaveButtonStatus(isSaveEnabled(props.configuration))

                        }}
                        renderConfigurationValueLabel={renderConfigurationValueLabel}
                        intl={props.intl}
                    />
                )
            })} 


    </div>
}

const renderConfigurationValueLabel = (key: string) => {
    switch (key) {
    case "defaultIncomeAccountId":
        return <FormattedMessage
            id="integration.form.edit.freshbooks.default_income_account_id"
            defaultMessage="Default income account for product exports"
        />
    // case "defaultExpenseAccountId":
    //     return <FormattedMessage
    //         id="integration.form.edit.freshbooks.default_expense_category_id"
    //         defaultMessage="Default expense category for purchase orders"
    //     />
    default:
        return key
    }
}

const isSaveEnabled = (configuration: object): boolean => {
    return !(configuration[INTEGRATION_CONFIGURATION_KEYS.defaultInventoryLocationId] === "" )
}

export default injectIntl(FreshbooksFormComponent)


// WEBPACK FOOTER //
// ./src/integration/form/freshbooks/FreshbooksFormComponent.tsx